import du from '../utils/dom-utilities';
import scrollTo from '../utils/ScrollTo';

export default function scrollToFormError() {
    du.queryAll('.js-form').forEach((form) => {
        let nodesError = du.queryAll('.error', form);

        if (nodesError.length) {
            let offset = 0;
            if (document.body.querySelector('.navbar')) {
                offset += document.body.querySelector('.navbar').getBoundingClientRect().height;
            }
            if (document.body.querySelector('.anchors')) {
                offset += document.body.querySelector('.anchors').getBoundingClientRect().height;
            }

            let positionToGo = nodesError.map((item)=>{
                return item.getBoundingClientRect().top;
            }).reduce((acc, current) => {
                return (!acc || ( acc > current )) ? current : acc;
            }, null);

            let offsetScroll = positionToGo - (offset + (document.body.getBoundingClientRect().top - 10));

            scrollTo(document.scrollingElement || document.documentElement, offsetScroll, 400);
        }
    });
}



// WEBPACK FOOTER //
// ./src/main/js/components/scrollToFormError.js